import { createSlice } from "@reduxjs/toolkit";
import { AgrupamentoContaBancoModel } from "../../../models/agrupamentoContaBanco/agrupamentoContaBancoModel";
import { buscarAgrupamentoContaBanco } from "../../../services/agrupamentoContaBancoService";

export interface AgrupamentoContaBancoState {
  loading: boolean;
  list: AgrupamentoContaBancoModel[];
}

const initialState: AgrupamentoContaBancoState = {
  loading: false,
  list: [],
};

export const agrupamentoContaBancoSlice = createSlice({
  name: "agrupamentoContaBanco",
  initialState,
  reducers: {
    resetAgrupamentoContaBanco: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase("resetAll", () => initialState);

    //buscar agrupamento conta banco
    builder.addCase(buscarAgrupamentoContaBanco.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarAgrupamentoContaBanco.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarAgrupamentoContaBanco.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { resetAgrupamentoContaBanco } = agrupamentoContaBancoSlice.actions;
export default agrupamentoContaBancoSlice.reducer;
